import { routesApp } from "@/constans/routes";
import { Navigate } from "react-router-dom";

export const RedirectToBrowse = () =>
    <Navigate to={routesApp.browse} replace />
